// Sin Tiempo header blur + reveal + stagger (safe ordering)
(() => {
  // 0) Gate: only enable reveal CSS after JS is running
  document.documentElement.classList.add('reveal-ready');

  // 1) Header glass on scroll
  const header = document.querySelector('.header-wrapper');
  function onScrollHeader() {
    if (!header) return;
    const y = window.scrollY || document.documentElement.scrollTop;
    header.classList.toggle('is-scrolled', y > 12);
  }
  window.addEventListener('scroll', onScrollHeader, { passive: true });
  onScrollHeader();

  // 2) Auto-apply .st-reveal to most sections BEFORE we select them
  const skip = ['.section-header', 'footer', '.announcement-bar-section'];
  document.querySelectorAll('.shopify-section').forEach(sec => {
    if (skip.some(sel => sec.closest(sel))) return;
    if (!sec.classList.contains('st-reveal')) sec.classList.add('st-reveal');
  });

  // 3) Reveal-on-view for all .st-reveal (now includes auto-applied ones)
  const revealEls = document.querySelectorAll('.st-reveal');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.15 });
    revealEls.forEach((el) => io.observe(el));
  } else {
    revealEls.forEach((el) => el.classList.add('is-visible'));
  }

  // 4) Stagger: when a .st-stagger parent becomes visible, cascade children
  const parents = document.querySelectorAll('.st-stagger');
  if (parents.length && 'IntersectionObserver' in window) {
    const DELAY_MS = 90;
    const pIO = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const p = entry.target;
        p.classList.add('is-visible');
        Array.from(p.children).forEach((child, i) => {
          child.style.transitionDelay = (i * DELAY_MS) + 'ms';
        });
        pIO.unobserve(p);
      });
    }, { threshold: 0.15 });
    parents.forEach((p) => pIO.observe(p));
  }

/* === FKX-y Header Flourish Pack (JS) === */

// 1) Scroll progress bar (auto-inject)
let stProgress = document.querySelector('.st-progress');
if (!stProgress) {
  stProgress = document.createElement('div');
  stProgress.className = 'st-progress';
  document.body.appendChild(stProgress);
}
const updateProgress = () => {
  const doc = document.documentElement;
  const h = doc.scrollHeight - doc.clientHeight;
  const p = h ? (doc.scrollTop / h) : 0;
  stProgress.style.width = (p * 100) + '%';
};
window.addEventListener('scroll', updateProgress, { passive: true });
updateProgress();

// 2) Smart hide header on scroll down, reveal on scroll up
let lastY = 0;
const dirTick = () => {
  const y = window.scrollY || document.documentElement.scrollTop;
  const down = y > lastY && y > 80; // start hiding after 80px
  header?.classList.toggle('header--hidden', down);
  lastY = y;
};
window.addEventListener('scroll', dirTick, { passive: true });

// 3) Magnetic hover for menu items (desktop only)
if (window.matchMedia('(min-width: 990px)').matches && window.matchMedia('(hover:hover)').matches) {
  document.querySelectorAll('.header__menu-item').forEach((link) => {
    link.addEventListener('mousemove', (e) => {
      const r = link.getBoundingClientRect();
      const x = (e.clientX - r.left - r.width/2) / r.width;
      const y = (e.clientY - r.top - r.height/2) / r.height;
      link.style.transform = `translate(${x*6}px, ${y*4}px)`;
    });
    link.addEventListener('mouseleave', () => { link.style.transform = ''; });
  });
}

// 4) Cmd/Ctrl+K opens theme search
function openSearch(){
  const btn = document.querySelector('.header__icon--search, [data-action="open-search"], button[aria-controls="Search-In-Modal"]');
  if (btn) btn.click();
  else document.querySelector('input[type="search"], input[name="q"]')?.focus();
}
window.addEventListener('keydown', (e) => {
  if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') { e.preventDefault(); openSearch(); }
});

/* === Nav hover video previews (desktop) === */

// 1) Map menu item labels to MP4 URLs (replace with your actual file URLs)
const NAV_VIDEO_MAP = {
  'Shop':     'https://cdn.shopify.com/s/files/…/shop.mp4',
  'New Drop': 'https://cdn.shopify.com/s/files/…/newdrop.mp4',
  'Lookbook': 'https://cdn.shopify.com/s/files/…/lookbook.mp4'
  // Add more: 'About': 'https://…/about.mp4'
};

// 2) Build the preview panel once
let navPrev = document.querySelector('.nav-preview');
if (!navPrev) {
  navPrev = document.createElement('div');
  navPrev.className = 'nav-preview';
  navPrev.innerHTML = '<video muted loop playsinline></video>';
  document.body.appendChild(navPrev);
}
const navVideo = navPrev.querySelector('video');

// 3) Hook up desktop menu items
const isDesktop = () => window.matchMedia('(min-width: 990px)').matches && window.matchMedia('(hover:hover)').matches;

document.querySelectorAll('.header__menu-item').forEach((link) => {
  const label = (link.textContent || '').trim();
  const src = NAV_VIDEO_MAP[label];
  if (!src) return;

  link.addEventListener('mouseenter', () => {
    if (!isDesktop()) return;
    if (navVideo.getAttribute('src') !== src) {
      navVideo.setAttribute('src', src);
      navVideo.load();
    }
    navPrev.classList.add('nav-preview--show');
    navVideo.play().catch(()=>{});
  });

  link.addEventListener('mouseleave', () => {
    navPrev.classList.remove('nav-preview--show');
  });
});

// hide panel when leaving header area
document.querySelector('.header-wrapper')?.addEventListener('mouseleave', () => {
  navPrev.classList.remove('nav-preview--show');
});




})();
// Tag common grids so they reveal + stagger automatically
['.product-grid .grid', '.collection-list .grid', '.featured-collection .grid', '.blog-articles .blog__posts']
  .forEach((sel) => {
    document.querySelectorAll(sel).forEach((el) => {
      el.classList.add('st-reveal', 'st-stagger');
    });
  });
